import fetcher from './fetcher'

export const signin = (body: { email: string; password: string }) => {
  return fetcher(`/signin`, body)
}

export const signup = (body: {
  email: string
  password: string
  firstName: string
  lastName: string
}) => {
  return fetcher(`/signup`, body)
}
